import React from "react";
import "./styles.css";
import SyncIcon from '@mui/icons-material/Sync';
import { makeStyles } from '@mui/styles';
import { CircularProgress, useTheme, useMediaQuery } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    floatingSyncButton: {
        position: 'fixed',
        marginRight: "1.75%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "1vw",
        padding: "0.5% 1.25%",
        height: "7.25vh",
        bottom: "5%",
        right: "2%",
        background: "var(--gradient, linear-gradient(270deg, #051572 0%, #0820B4 100%))",
        color: "#FFFFFF",
        borderRadius: "8px",
        cursor: "pointer",
        zIndex: 1000,
        "&:hover": {
            border: "1px solid rgba(255, 255, 255, 0.12)",
            background: "var(--Gradient, linear-gradient(270deg, #051572 7.32%, #0820B4 92.68%))",
            boxShadow: "0px 0px 4px 1px rgba(8, 32, 180, 0.09), 0px 1px 6px 2px rgba(13, 30, 131, 0.31)",
        },
        "&:disabled": {
            background: "#ccc",
            cursor: "not-allowed",
            "&:hover": {
                background: "#ccc",
                boxShadow: "none"
            }
        },
        "@media (max-width: 1200px)": {
            padding: "0.5% 1%",
            height: "6.5vh",
        },
        "@media (max-width: 900px)": {
            padding: "0.5% 0.75%",
            height: "6vh",
            right: "1%",
        },
    },
    mobileSyncButton: {
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        padding: "14px 16px",
        minHeight: "48px",
        background: "var(--gradient, linear-gradient(270deg, #051572 0%, #0820B4 100%))",
        color: "#FFFFFF",
        cursor: "pointer",
        zIndex: 1000,
        "&:hover": {
            background: "var(--Gradient, linear-gradient(270deg, #051572 7.32%, #0820B4 92.68%))",
        },
        "&:disabled": {
            background: "#ccc",
            cursor: "not-allowed",
        },
    },
    iconContainer: {
        borderRadius: "50%",
        background: "#2338AE",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "2rem",
        height: "2rem",
    },
    iconContainerMobile: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    textContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
}));

const FloatingSyncButton = ({ onClick, disabled, syncing, count }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const content = (
        <>
            <div className={isMobile ? classes.iconContainerMobile : classes.iconContainer}>
                {syncing ? (
                    <CircularProgress size={isMobile ? 22 : 16} color="inherit" />
                ) : (
                    <SyncIcon style={{ fontSize: isMobile ? '1.5rem' : '1.2rem' }} />
                )}
            </div>
            <div className={classes.textContainer}>
                <span style={{ fontWeight: 600, fontSize: isMobile ? '1rem' : undefined }}>
                    {syncing ? 'Syncing...' : count > 0 ? `Sync All (${count})` : 'Sync All'}
                </span>
            </div>
        </>
    );

    if (isMobile) {
        return (
            <div
                className={classes.mobileSyncButton}
                onClick={disabled ? null : onClick}
                style={{
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.6 : 1,
                }}
            >
                {content}
            </div>
        );
    }

    return (
        <div
            className={classes.floatingSyncButton}
            onClick={disabled ? null : onClick}
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
            }}
        >
            {content}
        </div>
    );
};

export default FloatingSyncButton;
